export default __webpack_public_path__ + "static/media/Wave-33.3s-1920px.f2d7b00e.svg";